<template>
  <div class="page">
    <div class="weui-msg" v-if="applyAble && authed">
      <div class="weui-msg__icon-area">
        <i :class="iconClass"></i>
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">{{info}}</h2>

        <div v-if="(userInfo.paotuiStatus==-1 || userInfo.paotuiStatus==2) && haveIdCard && haveStudentCard">
          <p class="weui-msg__desc">
            申请加入校圆通跑腿，必须事先
          </p>
          <p>
            <label for="weuiAgree" class="weui-agree">
              <input id="weuiAgree" type="checkbox" v-model="agree" class="weui-agree__checkbox" />
              <span class="weui-agree__text">
                阅读并同意
                <a href="javascript:void(0);" @click="agreement">《校圆通跑腿协议》</a>
              </span>
            </label>
          </p>
        </div>

        <div v-if="(userInfo.paotuiStatus==-1 || userInfo.paotuiStatus==2) && (!haveIdCard || !haveStudentCard)">
          <p class="weui-msg__desc">
            请先上传身份证和学生证耐心等待实名认证审核，审核通过才能申请校圆通跑腿。
          </p>
        </div>

        <div v-if="userInfo.paotuiStatus == 0">
          <p class="weui-msg__desc">您的跑腿申请正在审核中，请耐心等待，如有疑问，请致电平台客服。
            <a href="javascript:void(0);" @click="agreement">《校圆通跑腿协议》</a>
          </p>
        </div>

        <div v-if="userInfo.paotuiStatus == 1">
          <p class="weui-msg__desc">您已经成功加入校圆通跑腿。
            <a href="javascript:void(0);" @click="agreement">《校圆通跑腿协议》</a>
          </p>
        </div>
      </div>
      <div class="weui-cells">
        <div class="weui-cell" style="text-align: auto;" v-if="haveIdCard" @click="showImagePreview(userInfo.idCardUrl)">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>身份证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.idCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="!haveIdCard">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>身份证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.idCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="haveStudentCard" @click="showImagePreview(userInfo.studentCardUrl)">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>学生证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.studentCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="!haveStudentCard">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>学生证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.studentCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="(userInfo.paotuiStatus==-1 || userInfo.paotuiStatus==2) && haveIdCard && haveStudentCard && paotuiApplyNeedInvitation">
          <div class="weui-cell__bd" style="text-align: left;"><label class="weui-label">跑腿邀请码</label></div>
          <div class="weui-cell__hd">
            <input class="weui-input" v-model="invitation" type="number" placeholder="请填入跑腿邀请号" style="text-align: right;" />
          </div>
        </div>
      </div>

      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="joinPoatui" v-if="(userInfo.paotuiStatus==-1 || userInfo.paotuiStatus==2) && haveIdCard && haveStudentCard">确定申请加入</a>
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="gotoAuth" v-if="(userInfo.paotuiStatus==-1 || userInfo.paotuiStatus==2) && (!haveIdCard || !haveStudentCard)">去上传证件</a>
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="gotoRobbing" v-if="userInfo.paotuiStatus == 1">去接单赚外快</a>
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="paotuiMakeMoney" v-if="userInfo.paotuiStatus == 1" style="background-color: gold;">跑腿怎么赚钱</a>
          <a href="javascript:;" class="weui-btn weui-btn_default" @click="back">返回个人中心</a>
        </p>
      </div>
    </div>
    <div class="weui-msg" v-if="applyAble && !authed && !authing">
      <div class="weui-msg__icon-area">
        <i class="weui-icon-waiting weui-icon_msg"></i>
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">须实名认证（身份证+学生证）</h2>

        <div>
          <p class="weui-msg__desc">
            申请加入跑腿必须事先完成实名认证，<span v-if="userInfo.authStatus == -1">请先去实名认证。</span><span v-if="userInfo.authStatus==2 && userInfo.rejectComment" style="color: orangered; font-weight: bold;">您上次实名认证不通过的原因是：{{userInfo.rejectComment}} 请修改您的认证信息重新认证。</span>
          </p>
        </div>
      </div>
      <div class="weui-cells">
        <div class="weui-cell" style="text-align: auto;" v-if="haveIdCard" @click="showImagePreview(userInfo.idCardUrl)">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>身份证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.idCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="!haveIdCard">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>身份证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.idCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="haveStudentCard" @click="showImagePreview(userInfo.studentCardUrl)">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>学生证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.studentCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="!haveStudentCard">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>学生证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.studentCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
      </div>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="gotoAuth">立即实名认证</a>
          <a href="javascript:;" class="weui-btn weui-btn_default" @click="back">返回个人中心</a>
        </p>
      </div>
    </div>
    <div class="weui-msg" v-if="applyAble && !authed && authing">
      <div class="weui-msg__icon-area">
        <i class="weui-icon-waiting weui-icon_msg"></i>
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">实名认证中</h2>
        <div>
          <p class="weui-msg__desc">
            您提交的实名认证申请正在审核中，审核结果将会以微信信息的形式发送给您，请耐心等待。
          </p>
        </div>
      </div>
      <div class="weui-cells">
        <div class="weui-cell" style="text-align: auto;" v-if="haveIdCard" @click="showImagePreview(userInfo.idCardUrl)">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>身份证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.idCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="!haveIdCard">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>身份证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.idCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="haveStudentCard" @click="showImagePreview(userInfo.studentCardUrl)">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>学生证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.studentCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
        <div class="weui-cell" style="text-align: auto;" v-if="!haveStudentCard">
          <div class="weui-cell__bd" style="text-align: left;">
            <p>学生证照片</p>
          </div>
          <div class="weui-cell__hd"><img :src="userInfo.studentCardUrl" style="width:20px;margin-right:5px;display:block"></div>
        </div>
      </div>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <a href="javascript:;" class="weui-btn weui-btn_default" @click="back">返回个人中心</a>
        </p>
      </div>
    </div>
    <div class="weui-msg" v-if="!applyAble">
      <div class="weui-msg__icon-area">
        <i class="weui-icon-warn weui-icon_msg"></i>
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">暂未开通</h2>

        <div>
          <p class="weui-msg__desc" v-if="userInfo.worksite.paotuiAble">对不起，本校线上跑腿申请暂未开通，线下申请请致电服务中心
            <a :href="'tel:'+userInfo.worksite.servicePhone">{{userInfo.worksite.servicePhone}}</a> 咨询。</p>
          <p class="weui-msg__desc" v-if="!userInfo.worksite.paotuiAble">对不起，本校跑腿业务暂未开通，敬请期待，如有疑问请致电服务中心
            <a :href="'tel:'+userInfo.worksite.servicePhone">{{userInfo.worksite.servicePhone}}</a> 咨询。</p>
        </div>
      </div>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <a href="javascript:;" class="weui-btn weui-btn_default" @click="back">返回个人中心</a>
        </p>
      </div>
    </div>
    <!-- <div class="weui-msg__extra-area">
      <div class="weui-footer">
        <p class="weui-footer__links">
          <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
        </p>
        <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import config from "../../config/config.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      iconClass: "",
      info: "",
      userInfo: {},
      authed: false,
      authing: false,
      applyAble: true,
      paotuiApplyNeedInvitation: true,
      agree: false,
      imgs: [],
      haveIdCard: false,
      haveStudentCard: false,
      invitation: null,
      year: moment().format("YYYY")
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(res => {
        if (res.data.success) {
          this.userInfo = res.data.data;
          this.paotuiApplyNeedInvitation = this.userInfo.worksite.paotuiApplyNeedInvitation;

          if (!this.userInfo.idCardUrl) {
            this.userInfo.idCardUrl = config.defaultImgBase64;
          } else {
            this.haveIdCard = true;
          }
          if (!this.userInfo.studentCardUrl) {
            this.userInfo.studentCardUrl = config.defaultImgBase64;
          } else {
            this.haveStudentCard = true;
          }

          this.authed = this.userInfo.authStatus == 1 ? true : false;
          this.authing = this.userInfo.authStatus == 0 ? true : false;
          this.applyAble =
            (this.userInfo.worksite.paotuiAble &&
              this.userInfo.worksite.paotuiApplyAble) ||
            this.userInfo.paotuiStatus == 1;

          /**
           * 获取当前用户跑腿状态
           * 如果当前状态不是待申请-1 不通过2这两种状态
           * 则显示申请
           * 如果当前状态是待审核0
           * 则显示叹号，提示在审核
           * 如果当前状态是已加入
           * 则显示打勾
           */
          if (
            this.userInfo.paotuiStatus == -1 ||
            this.userInfo.paotuiStatus == 2
          ) {
            this.iconClass = "weui-icon-waiting weui-icon_msg";
            if (!this.haveIdCard && !this.haveStudentCard) {
              this.info = "待上传身份证和学生证";
            } else if (!this.haveIdCard) {
              this.info = "待上传身份证";
            } else if (!this.haveStudentCard) {
              this.info = "待上传学生证";
            } else {
              this.info = "待申请加入";
            }
          } else if (this.userInfo.paotuiStatus == 0) {
            this.iconClass = "weui-icon-warn weui-icon_msg-primary";
            this.info = "待审核";
          } else if (this.userInfo.paotuiStatus == 1) {
            this.info = "您已加入跑腿";
            this.iconClass = "weui-icon-success weui-icon_msg";
          }
        } else {
          weui.alert("获取用户信息失败");
          console.log(res.data.message);
        }
      })
      .catch(err => {
        weui.alert("获取用户信息失败");
      });
  },
  methods: {
    showImagePreview(img) {
      this.imgs = [img];
      this.$createImagePreview({
        imgs: this.imgs
      }).show();
    },
    agreement() {
      this.$router.push("/paotuiAgreement");
    },
    joinPoatui() {
      if (this.paotuiApplyNeedInvitation && !this.invitation) {
        weui.alert("请填入跑腿邀请码");
        return;
      } else if (!this.agree) {
        weui.alert("请先阅读并同意校圆通跑腿协议");
        return;
      } else {
        let that = this;
        if (!this.applyAble) {
          weui.alert("线上跑腿申请已被关闭，如有疑问请咨询平台客服。");
        } else {
          if (this.userInfo.sex == 0) {
            weui.alert("由于宿舍管理限制，所以请您先到个人中心登记您的性别");
            return;
          } else {
            weui.confirm(
              "确定申请加入跑腿？",
              function() {
                let params = {
                  needInvitation: that.paotuiApplyNeedInvitation
                };
                if (that.paotuiApplyNeedInvitation) {
                  params.invitation = that.invitation;
                }
                axios
                  .put("/api/user/applypaotui", params)
                  .then(res => {
                    if (res.data.success) {
                      weui.toast("申请成功");
                      that.$router.push("/my/" + that.encodeToken);
                    } else {
                      setTimeout(function() {
                        weui.alert(res.data.message);
                      }, 500);
                    }
                  })
                  .catch(err => {
                    weui.alert("申请跑腿失败");
                  });
              },
              function() {}
            );
          }
        }
      }
    },
    gotoAuth() {
      this.$router.push("/authApply/1/paotuiApply/" + this.encodeToken);
    },
    paotuiMakeMoney() {
      this.$router.push("/paotuiMakeMoney");
    },
    gotoRobbing() {
      this.$router.push("/robbing/" + this.encodeToken);
    },
    back() {
      this.$router.push("/my/" + this.encodeToken);
    }
  }
};
</script>


<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/operations/PaotuiApply.vue